/**
 * Configuration for DICOM download job polling
 */
export const DOWNLOAD_CONFIG = {
  /**
   * Polling interval in milliseconds (default: 5 seconds)
   */
  POLLING_INTERVAL: 5000,

  /**
   * Maximum number of polling attempts before giving up (default: 100)
   * With 5s interval, this gives ~8 minutes total
   */
  MAX_POLLING_ATTEMPTS: 100,

  /**
   * Maximum age of stored jobs in milliseconds (default: 24 hours)
   * Jobs older than this will be cleaned up
   */
  MAX_JOB_AGE: 24 * 60 * 60 * 1000,

  /**
   * Storage key for download jobs
   */
  STORAGE_KEY: "NXMD.DownloadJobs",
};

